import React from "react";

import { cn } from "../../lib/css";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("bg-background animate-pulse rounded-md", className)}
      {...props}
    />
  );
}

export { Skeleton };
